import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import ContentBlock from "../../../../../../components/wpl/content-block/src";
import {
    DataEventProps,
    Row
} from "../../../../../../libraries/wpl/foundations/src";

const sectionStyles = css({
    "color": "#ffffff",
    "backgroundPosition": "center",
    "backgroundRepeat": "no-repeat",
    "padding": "16px 0",
    "backgroundSize": "cover",
    "backgroundImage":
        "url(https://wac-cdn.atlassian.com/dam/jcr:efb3c307-d2fb-42af-8536-45461774796a/JSW_Blue%20Grid.png?cdnVersion=ece)",
    "@media only screen and (min-width: 768px)": {
        padding: "64px 0",
        backgroundImage:
            "url(https://wac-cdn.atlassian.com/dam/jcr:8a9ac4bd-71f9-4af4-b859-f9c132e12f80/JSW_CTA_bg.png?cdnVersion=ece)"
    }
});
const rowContainerStyles = css({
    "paddingLeft": "16px",
    "paddingRight": "16px",
    ".row-layout": {
        width: "100%",
        paddingInlineStart: "0px",
        paddingInlineEnd: "0px"
    },
    "@media only screen and (min-width: 768px)": {
        display: "flex",
        padding: "0 120px",
        marginInlineStart: "auto",
        marginInlineEnd: "auto"
    }
});
const contentBlockStyles = css({
    "> div.text-section": {
        "maxWidth": "800px",
        "margin": "0 auto",
        "> h2": {
            "fontSize": "24px",
            "fontWeight": "500",
            "lineHeight": "32px",
            "paddingTop": "16px",
            "marginBlockEnd": "8px",
            "@media only screen and (min-width: 768px)": {
                marginBlockEnd: "24px",
                fontSize: "36px",
                fontWeight: "500",
                paddingBlockStart: "16px",
                lineHeight: "48px"
            }
        },
        "> div.contentBlock-linkFlex": {
            margin: "0 0 22px"
        }
    }
});

const CtaSectionContentBlock = () => {
    const intl = useIntl();
    const linkDataEventProps: DataEventProps = {
        "data-event-component": "linkButton",
        "data-event-container": "ctaSection",
        "data-event": "clicked",
        "data-product-key": "jiraSoftware-PaidLpJswPm"
    };

    return (
        <ContentBlock
            css={contentBlockStyles}
            headerType="h2"
            headerText={intl.formatMessage({
                id: "JiraSoftwarePageTemplate.PaidLpJswPm.ctaSection.unifyYourTeamsWorkWithJira",
                defaultMessage: "Unify your team's work with Jira"
            })}
            orientation="vertical"
            ctaProps={{
                buttonProps: {
                    text: intl.formatMessage({
                        id: "JiraSoftwarePageTemplate.PaidLpJswPm.ctaSection.getItFree",
                        defaultMessage: "Get it free"
                    }),
                    color: "yellow",
                    url: "#start-trial",
                    dataEventProps: linkDataEventProps
                }
            }}
            isCentered
        />
    );
};

const CTASectionPaidLpJswPm = () => {
    return (
        <section css={sectionStyles}>
            <div css={rowContainerStyles}>
                <Row layout="12" alignItems="center">
                    <CtaSectionContentBlock />
                </Row>
            </div>
        </section>
    );
};

export default CTASectionPaidLpJswPm;
